var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGestelLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "108px",
    height: "43px",
    viewBox: "0 0 107 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(99.607843%,99.607843%,99.607843%)",
      fillOpacity: 1
    },
    d: "M -0.03125 -0.03125 C 35.636719 -0.03125 71.300781 -0.03125 106.96875 -0.03125 C 106.96875 14.300781 106.96875 28.636719 106.96875 42.96875 C 71.300781 42.96875 35.636719 42.96875 -0.03125 42.96875 C -0.03125 28.636719 -0.03125 14.300781 -0.03125 -0.03125 Z M -0.03125 -0.03125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.627451%,20.784314%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 21.671875 0.859375 C 23.144531 0.753906 23.683594 1.414062 23.292969 2.832031 C 22.730469 3.535156 22.0625 3.652344 21.292969 3.179688 C 20.855469 2.714844 20.738281 2.171875 20.941406 1.558594 C 21.128906 1.261719 21.371094 1.027344 21.671875 0.859375 Z M 21.671875 0.859375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(47.45098%,54.509804%,57.254902%)",
      fillOpacity: 1
    },
    d: "M 29.921875 2.066406 C 29.605469 2.0625 29.285156 2.082031 28.972656 2.132812 C 29.140625 2.035156 29.332031 1.992188 29.542969 2.003906 C 29.683594 2.003906 29.808594 2.023438 29.921875 2.066406 Z M 29.921875 2.066406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.235294%,20.392157%,24.705882%)",
      fillOpacity: 1
    },
    d: "M 29.921875 2.066406 C 30.816406 2.359375 31.207031 2.972656 31.097656 3.910156 C 30.789062 4.898438 30.121094 5.3125 29.097656 5.152344 C 28.023438 4.660156 27.714844 3.867188 28.179688 2.765625 C 28.378906 2.472656 28.640625 2.257812 28.972656 2.132812 C 29.285156 2.082031 29.605469 2.0625 29.921875 2.066406 Z M 29.921875 2.066406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.019608%,21.176471%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 14.375 2.578125 C 15.460938 2.488281 15.917969 2.976562 15.738281 4.039062 C 15.363281 4.660156 14.84375 4.820312 14.183594 4.515625 C 13.6875 4.035156 13.613281 3.492188 13.960938 2.894531 C 14.109375 2.792969 14.246094 2.6875 14.375 2.578125 Z M 14.375 2.578125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(1.960784%,55.686275%,73.333333%)",
      fillOpacity: 1
    },
    d: "M 7.710938 4.867188 C 9.429688 4.769531 10.5625 5.53125 11.105469 7.15625 C 11.335938 8.9375 10.605469 10.113281 8.917969 10.6875 C 7.035156 10.917969 5.84375 10.121094 5.332031 8.300781 C 5.230469 6.53125 6.023438 5.386719 7.710938 4.867188 Z M 7.710938 4.867188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(2.745098%,56.078431%,73.333333%)",
      fillOpacity: 1
    },
    d: "M 21.671875 5.949219 C 22.855469 5.824219 23.671875 6.3125 24.117188 7.410156 C 24.25 9.183594 23.4375 10.042969 21.671875 9.988281 C 20.527344 9.609375 20.007812 8.8125 20.117188 7.601562 C 20.324219 6.75 20.84375 6.199219 21.671875 5.949219 Z M 21.671875 5.949219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.235294%,20.784314%,24.705882%)",
      fillOpacity: 1
    },
    d: "M 35.382812 5.949219 C 36.480469 5.851562 37.234375 6.320312 37.632812 7.347656 C 37.703125 9.015625 36.910156 9.765625 35.253906 9.605469 C 34.03125 9.027344 33.683594 8.105469 34.207031 6.839844 C 34.515625 6.425781 34.90625 6.128906 35.382812 5.949219 Z M 35.382812 5.949219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(3.529412%,56.078431%,73.333333%)",
      fillOpacity: 1
    },
    d: "M 16.53125 7.09375 C 17.667969 6.949219 18.417969 7.417969 18.785156 8.492188 C 18.914062 9.625 18.4375 10.378906 17.355469 10.75 C 15.761719 10.804688 15.03125 10.03125 15.167969 8.429688 C 15.410156 7.75 15.867188 7.304688 16.53125 7.09375 Z M 16.53125 7.09375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.411765%,21.568627%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 27.128906 8.492188 C 27.851562 8.460938 28.160156 8.800781 28.050781 9.507812 C 27.757812 9.984375 27.367188 10.078125 26.875 9.796875 C 26.492188 9.269531 26.578125 8.835938 27.128906 8.492188 Z M 27.128906 8.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(3.921569%,56.078431%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 12.28125 10.082031 C 13.601562 10.082031 14.246094 10.738281 14.214844 12.054688 C 13.882812 13.148438 13.15625 13.582031 12.027344 13.359375 C 10.964844 12.832031 10.65625 12.015625 11.105469 10.910156 C 11.398438 10.480469 11.789062 10.207031 12.28125 10.082031 Z M 12.28125 10.082031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.411765%,21.568627%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 31.445312 11.289062 C 32.441406 11.332031 32.769531 11.820312 32.429688 12.753906 C 32.054688 13.164062 31.621094 13.238281 31.128906 12.976562 C 30.539062 12.277344 30.644531 11.714844 31.445312 11.289062 Z M 31.445312 11.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(2.352941%,55.686275%,73.333333%)",
      fillOpacity: 1
    },
    d: "M 3.585938 11.417969 C 5.15625 11.328125 6.179688 12.027344 6.664062 13.515625 C 6.847656 15.152344 6.160156 16.222656 4.601562 16.730469 C 3.039062 16.914062 1.988281 16.269531 1.460938 14.789062 C 1.234375 13.054688 1.945312 11.933594 3.585938 11.417969 Z M 3.585938 11.417969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.058824%,56.470588%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 21.738281 11.546875 C 22.75 11.574219 23.160156 12.082031 22.972656 13.070312 C 22.648438 13.632812 22.171875 13.832031 21.546875 13.675781 C 20.867188 13.261719 20.707031 12.699219 21.070312 11.992188 C 21.261719 11.785156 21.484375 11.636719 21.738281 11.546875 Z M 21.738281 11.546875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.843137%,20.392157%,24.705882%)",
      fillOpacity: 1
    },
    d: "M 39.507812 11.992188 C 41.039062 11.875 41.90625 12.574219 42.109375 14.089844 C 42.050781 15.113281 41.542969 15.800781 40.585938 16.15625 C 39.246094 16.402344 38.367188 15.882812 37.953125 14.597656 C 37.753906 13.296875 38.273438 12.425781 39.507812 11.992188 Z M 39.507812 11.992188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(5.490196%,56.470588%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 24.910156 12.117188 C 25.953125 12.007812 26.492188 12.476562 26.527344 13.515625 C 26.246094 14.375 25.664062 14.683594 24.78125 14.4375 C 24.089844 13.972656 23.929688 13.367188 24.308594 12.625 C 24.484375 12.417969 24.683594 12.25 24.910156 12.117188 Z M 24.910156 12.117188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.45098%,56.862745%,74.117647%)",
      fillOpacity: 1
    },
    d: "M 18.4375 12.308594 C 19.253906 12.351562 19.621094 12.777344 19.546875 13.582031 C 19.292969 14.148438 18.859375 14.371094 18.246094 14.25 C 17.601562 13.859375 17.464844 13.339844 17.832031 12.691406 C 18.015625 12.519531 18.214844 12.394531 18.4375 12.308594 Z M 18.4375 12.308594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.313725%,56.078431%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 27.765625 13.898438 C 28.96875 13.800781 29.53125 14.355469 29.445312 15.550781 C 29.074219 16.453125 28.429688 16.742188 27.511719 16.410156 C 27.265625 16.269531 27.085938 16.070312 26.972656 15.808594 C 26.664062 14.921875 26.929688 14.285156 27.765625 13.898438 Z M 27.765625 13.898438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.058824%,56.862745%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 15.390625 14.40625 C 16.402344 14.347656 16.75 14.792969 16.4375 15.742188 C 15.902344 16.207031 15.414062 16.167969 14.976562 15.617188 C 14.804688 15.101562 14.945312 14.699219 15.390625 14.40625 Z M 15.390625 14.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.45098%,20%,24.313725%)",
      fillOpacity: 1
    },
    d: "M 105.445312 14.40625 C 105.445312 19.285156 105.445312 24.160156 105.445312 29.039062 C 105.023438 29.039062 104.597656 29.039062 104.175781 29.039062 C 104.175781 24.160156 104.175781 19.285156 104.175781 14.40625 C 104.597656 14.40625 105.023438 14.40625 105.445312 14.40625 Z M 105.445312 14.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(33.72549%,42.745098%,45.882353%)",
      fillOpacity: 1
    },
    d: "M 105.445312 14.40625 C 105.507812 19.292969 105.53125 24.191406 105.507812 29.101562 C 105.050781 29.121094 104.609375 29.101562 104.175781 29.039062 C 104.597656 29.039062 105.023438 29.039062 105.445312 29.039062 C 105.445312 24.160156 105.445312 19.285156 105.445312 14.40625 Z M 105.445312 14.40625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.235294%,20.784314%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 55.246094 22.296875 C 57.277344 22.296875 59.308594 22.296875 61.335938 22.296875 C 61.335938 22.527344 61.335938 22.761719 61.335938 22.996094 C 61.027344 26.519531 59.144531 28.628906 55.691406 29.324219 C 53.632812 29.660156 51.6875 29.34375 49.851562 28.371094 C 47.019531 26.519531 45.824219 23.902344 46.265625 20.515625 C 47.148438 17.042969 49.359375 15.039062 52.898438 14.503906 C 55.863281 14.210938 58.402344 15.101562 60.511719 17.175781 C 60.183594 17.527344 59.832031 17.855469 59.464844 18.160156 C 58.371094 17.164062 57.113281 16.453125 55.691406 16.03125 C 53.101562 15.472656 50.890625 16.140625 49.058594 18.035156 C 47.15625 20.601562 47.15625 23.164062 49.058594 25.730469 C 51 27.804688 53.359375 28.492188 56.132812 27.796875 C 58.140625 27.136719 59.367188 25.769531 59.816406 23.695312 C 58.292969 23.632812 56.769531 23.609375 55.246094 23.632812 C 55.246094 23.1875 55.246094 22.742188 55.246094 22.296875 Z M 55.246094 22.296875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(5.098039%,56.470588%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 9.171875 14.597656 C 10.566406 14.542969 11.167969 15.203125 10.980469 16.570312 C 10.546875 17.464844 9.859375 17.753906 8.917969 17.429688 C 7.945312 16.714844 7.839844 15.886719 8.597656 14.949219 C 8.792969 14.828125 8.984375 14.714844 9.171875 14.597656 Z M 9.171875 14.597656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.45098%,20%,24.313725%)",
      fillOpacity: 1
    },
    d: "M 85.835938 14.660156 C 86.257812 14.660156 86.679688 14.660156 87.105469 14.660156 C 87.105469 15.976562 87.105469 17.292969 87.105469 18.605469 C 87.824219 18.605469 88.542969 18.605469 89.261719 18.605469 C 89.261719 18.964844 89.261719 19.328125 89.261719 19.6875 C 88.5625 19.6875 87.867188 19.6875 87.167969 19.6875 C 87.105469 22.792969 87.082031 25.910156 87.105469 29.039062 C 86.679688 29.039062 86.257812 29.039062 85.835938 29.039062 C 85.835938 25.921875 85.835938 22.804688 85.835938 19.6875 C 85.222656 19.6875 84.609375 19.6875 83.996094 19.6875 C 83.996094 19.304688 83.996094 18.921875 83.996094 18.542969 C 84.609375 18.542969 85.222656 18.542969 85.835938 18.542969 C 85.835938 17.25 85.835938 15.957031 85.835938 14.660156 Z M 85.835938 14.660156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(16.862745%,28.235294%,32.156863%)",
      fillOpacity: 1
    },
    d: "M 85.835938 14.660156 C 85.835938 14.640625 85.835938 14.621094 85.835938 14.597656 C 86.277344 14.597656 86.722656 14.597656 87.167969 14.597656 C 87.167969 15.914062 87.167969 17.226562 87.167969 18.542969 C 87.886719 18.542969 88.605469 18.542969 89.324219 18.542969 C 89.34375 18.9375 89.324219 19.316406 89.261719 19.6875 C 89.261719 19.328125 89.261719 18.964844 89.261719 18.605469 C 88.542969 18.605469 87.824219 18.605469 87.105469 18.605469 C 87.105469 17.292969 87.105469 15.976562 87.105469 14.660156 C 86.679688 14.660156 86.257812 14.660156 85.835938 14.660156 Z M 85.835938 14.660156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.019608%,21.176471%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 34.175781 15.550781 C 35.339844 15.542969 35.773438 16.09375 35.476562 17.207031 C 34.789062 17.984375 34.132812 17.964844 33.507812 17.144531 C 33.28125 16.414062 33.503906 15.882812 34.175781 15.550781 Z M 34.175781 15.550781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(5.490196%,56.470588%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 13.484375 17.398438 C 13.957031 17.285156 14.304688 17.433594 14.535156 17.84375 C 14.605469 18.535156 14.296875 18.84375 13.613281 18.765625 C 13.296875 18.648438 13.128906 18.414062 13.105469 18.066406 C 13.140625 17.789062 13.265625 17.566406 13.484375 17.398438 Z M 13.484375 17.398438 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(10.980392%,22.745098%,27.058824%)",
      fillOpacity: 1
    },
    d: "M 29.921875 17.714844 C 30.589844 17.808594 30.714844 18.117188 30.304688 18.636719 C 29.765625 18.734375 29.542969 18.511719 29.636719 17.96875 C 29.726562 17.871094 29.820312 17.785156 29.921875 17.714844 Z M 29.921875 17.714844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(63.921569%,68.627451%,70.588235%)",
      fillOpacity: 1
    },
    d: "M 69.269531 18.289062 C 69.546875 18.261719 69.796875 18.304688 70.03125 18.414062 C 69.765625 18.394531 69.511719 18.351562 69.269531 18.289062 Z M 69.269531 18.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.627451%,20.784314%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 69.269531 18.289062 C 69.511719 18.351562 69.765625 18.394531 70.03125 18.414062 C 71.585938 18.75 72.78125 19.601562 73.617188 20.960938 C 74.082031 21.875 74.304688 22.851562 74.285156 23.886719 C 71.132812 23.886719 67.980469 23.886719 64.828125 23.886719 C 64.808594 24.152344 64.828125 24.40625 64.890625 24.648438 C 65.386719 27.035156 66.84375 28.171875 69.269531 28.050781 C 70.207031 27.972656 71.03125 27.636719 71.746094 27.035156 C 72.15625 26.585938 72.523438 26.109375 72.855469 25.601562 C 73.230469 25.796875 73.601562 25.996094 73.96875 26.207031 C 72.761719 28.453125 70.878906 29.492188 68.320312 29.324219 C 66.25 29.113281 64.777344 28.066406 63.90625 26.175781 C 62.828125 23.199219 63.558594 20.792969 66.097656 18.957031 C 67.082031 18.414062 68.140625 18.191406 69.269531 18.289062 Z M 69.269531 18.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.019608%,21.176471%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 78.726562 18.289062 C 80.09375 18.222656 81.234375 18.6875 82.152344 19.6875 C 81.898438 19.996094 81.613281 20.273438 81.296875 20.515625 C 80.898438 20.140625 80.445312 19.855469 79.933594 19.65625 C 78.894531 19.324219 78.121094 19.628906 77.617188 20.578125 C 77.519531 21.042969 77.605469 21.464844 77.871094 21.851562 C 78.539062 22.519531 79.308594 23.039062 80.1875 23.410156 C 80.804688 23.773438 81.34375 24.226562 81.804688 24.777344 C 82.597656 26.628906 82.125 28.058594 80.375 29.070312 C 78.984375 29.542969 77.695312 29.351562 76.503906 28.496094 C 76.292969 28.304688 76.101562 28.089844 75.933594 27.859375 C 76.171875 27.523438 76.449219 27.214844 76.757812 26.9375 C 77 27.148438 77.234375 27.371094 77.457031 27.605469 C 78.375 28.21875 79.308594 28.242188 80.25 27.671875 C 81.273438 26.546875 81.144531 25.574219 79.871094 24.742188 C 78.980469 24.300781 78.132812 23.789062 77.332031 23.21875 C 76.332031 22.164062 76.132812 20.964844 76.726562 19.625 C 77.222656 18.902344 77.890625 18.457031 78.726562 18.289062 Z M 78.726562 18.289062 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.627451%,20.784314%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 101.765625 23.886719 C 98.589844 23.886719 95.417969 23.886719 92.246094 23.886719 C 92.226562 24.046875 92.246094 24.195312 92.308594 24.332031 C 92.519531 26.164062 93.492188 27.382812 95.226562 27.988281 C 96.714844 28.277344 98.046875 27.960938 99.226562 27.035156 C 99.621094 26.574219 99.992188 26.097656 100.335938 25.601562 C 100.699219 25.816406 101.070312 26.019531 101.445312 26.207031 C 100 28.765625 97.820312 29.761719 94.910156 29.195312 C 92.796875 28.539062 91.496094 27.128906 91.007812 24.964844 C 90.578125 21.988281 91.710938 19.855469 94.402344 18.574219 C 97.226562 17.753906 99.457031 18.550781 101.097656 20.960938 C 101.578125 21.871094 101.800781 22.847656 101.765625 23.886719 Z M 101.765625 23.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(2.745098%,56.078431%,73.333333%)",
      fillOpacity: 1
    },
    d: "M 2.191406 19.113281 C 3.59375 19.050781 4.515625 19.6875 4.949219 21.023438 C 5.082031 22.316406 4.5625 23.238281 3.394531 23.789062 C 1.828125 24.1875 0.78125 23.625 0.253906 22.105469 C 0.0390625 20.535156 0.6875 19.539062 2.191406 19.113281 Z M 2.191406 19.113281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.843137%,20.392157%,24.705882%)",
      fillOpacity: 1
    },
    d: "M 41.03125 19.113281 C 42.992188 19.117188 43.910156 20.09375 43.789062 22.039062 C 43.28125 23.5625 42.234375 24.144531 40.648438 23.789062 C 39.5 23.261719 38.984375 22.359375 39.09375 21.085938 C 39.347656 20.035156 39.992188 19.378906 41.03125 19.113281 Z M 41.03125 19.113281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.039216%,98.431373%,98.431373%)",
      fillOpacity: 1
    },
    d: "M 68.066406 19.558594 C 69.84375 19.34375 71.273438 19.9375 72.347656 21.339844 C 72.5625 21.789062 72.722656 22.257812 72.824219 22.742188 C 70.203125 22.742188 67.578125 22.742188 64.957031 22.742188 C 65.355469 21.046875 66.390625 19.984375 68.066406 19.558594 Z M 68.066406 19.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(98.039216%,98.431373%,98.431373%)",
      fillOpacity: 1
    },
    d: "M 95.480469 19.558594 C 97.148438 19.320312 98.535156 19.832031 99.636719 21.085938 C 99.949219 21.601562 100.171875 22.152344 100.304688 22.742188 C 97.679688 22.742188 95.058594 22.742188 92.433594 22.742188 C 92.828125 21.074219 93.84375 20.015625 95.480469 19.558594 Z M 95.480469 19.558594 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(19.215686%,30.588235%,34.117647%)",
      fillOpacity: 1
    },
    d: "M 87.167969 19.6875 C 87.167969 22.824219 87.167969 25.964844 87.167969 29.101562 C 86.722656 29.101562 86.277344 29.101562 85.835938 29.101562 C 85.835938 29.082031 85.835938 29.058594 85.835938 29.039062 C 86.257812 29.039062 86.679688 29.039062 87.105469 29.039062 C 87.082031 25.910156 87.105469 22.792969 87.167969 19.6875 Z M 87.167969 19.6875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(63.529412%,68.235294%,70.196078%)",
      fillOpacity: 1
    },
    d: "M 85.835938 14.597656 C 85.835938 14.621094 85.835938 14.640625 85.835938 14.660156 C 85.835938 15.957031 85.835938 17.25 85.835938 18.542969 C 85.222656 18.542969 84.609375 18.542969 83.996094 18.542969 C 83.996094 18.921875 83.996094 19.304688 83.996094 19.6875 C 84.609375 19.6875 85.222656 19.6875 85.835938 19.6875 C 85.835938 22.804688 85.835938 25.921875 85.835938 29.039062 C 85.835938 29.058594 85.835938 29.082031 85.835938 29.101562 C 85.769531 25.996094 85.75 22.878906 85.769531 19.75 C 85.15625 19.75 84.542969 19.75 83.929688 19.75 C 83.929688 19.328125 83.929688 18.902344 83.929688 18.480469 C 84.542969 18.480469 85.15625 18.480469 85.769531 18.480469 C 85.75 17.175781 85.769531 15.878906 85.835938 14.597656 Z M 85.835938 14.597656 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(3.921569%,56.078431%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 8.027344 19.941406 C 9.289062 19.835938 9.851562 20.410156 9.710938 21.660156 C 9.273438 22.476562 8.628906 22.699219 7.773438 22.328125 C 7.152344 21.796875 7.035156 21.171875 7.425781 20.449219 C 7.601562 20.242188 7.800781 20.070312 8.027344 19.941406 Z M 8.027344 19.941406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.627451%,20.784314%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 35.191406 20.515625 C 36.332031 20.523438 36.832031 21.097656 36.683594 22.230469 C 36.226562 23.101562 35.558594 23.324219 34.683594 22.898438 C 34.121094 22.351562 34.023438 21.726562 34.398438 21.023438 C 34.625 20.78125 34.890625 20.613281 35.191406 20.515625 Z M 35.191406 20.515625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.843137%,56.862745%,74.117647%)",
      fillOpacity: 1
    },
    d: "M 12.976562 20.832031 C 13.582031 20.832031 13.824219 21.128906 13.707031 21.722656 C 13.523438 22.019531 13.261719 22.113281 12.914062 22.007812 C 12.621094 21.824219 12.523438 21.558594 12.628906 21.214844 C 12.714844 21.054688 12.832031 20.925781 12.976562 20.832031 Z M 12.976562 20.832031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(10.980392%,22.745098%,26.666667%)",
      fillOpacity: 1
    },
    d: "M 30.496094 20.960938 C 31.101562 20.917969 31.363281 21.195312 31.289062 21.785156 C 31.121094 22.117188 30.855469 22.234375 30.496094 22.136719 C 30.21875 21.96875 30.105469 21.726562 30.144531 21.40625 C 30.25 21.246094 30.367188 21.097656 30.496094 20.960938 Z M 30.496094 20.960938 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(18.823529%,30.196078%,33.72549%)",
      fillOpacity: 1
    },
    d: "M 55.246094 22.296875 C 57.285156 22.230469 59.339844 22.210938 61.402344 22.230469 C 61.421875 22.5 61.398438 22.753906 61.335938 22.996094 C 61.335938 22.761719 61.335938 22.527344 61.335938 22.296875 C 59.308594 22.296875 57.277344 22.296875 55.246094 22.296875 Z M 55.246094 22.296875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(82.352941%,84.313725%,85.098039%)",
      fillOpacity: 1
    },
    d: "M 74.285156 23.886719 C 71.164062 23.949219 68.035156 23.96875 64.890625 23.949219 C 64.890625 24.183594 64.890625 24.414062 64.890625 24.648438 C 64.828125 24.40625 64.808594 24.152344 64.828125 23.886719 C 67.980469 23.886719 71.132812 23.886719 74.285156 23.886719 Z M 74.285156 23.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(80.392157%,83.137255%,83.921569%)",
      fillOpacity: 1
    },
    d: "M 101.765625 23.886719 C 98.621094 23.949219 95.472656 23.96875 92.308594 23.949219 C 92.308594 24.078125 92.308594 24.203125 92.308594 24.332031 C 92.246094 24.195312 92.226562 24.046875 92.246094 23.886719 C 95.417969 23.886719 98.589844 23.886719 101.765625 23.886719 Z M 101.765625 23.886719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(10.980392%,22.745098%,26.666667%)",
      fillOpacity: 1
    },
    d: "M 29.921875 24.203125 C 30.625 24.257812 30.890625 24.617188 30.714844 25.285156 C 30.449219 25.664062 30.101562 25.761719 29.667969 25.570312 C 29.273438 25.1875 29.253906 24.785156 29.605469 24.363281 C 29.722656 24.3125 29.828125 24.261719 29.921875 24.203125 Z M 29.921875 24.203125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(10.588235%,57.647059%,74.509804%)",
      fillOpacity: 1
    },
    d: "M 13.675781 24.332031 C 14.285156 24.355469 14.453125 24.644531 14.183594 25.1875 C 13.605469 25.394531 13.34375 25.195312 13.390625 24.585938 C 13.480469 24.484375 13.574219 24.398438 13.675781 24.332031 Z M 13.675781 24.332031 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(5.098039%,56.470588%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 9.105469 25.285156 C 9.664062 25.207031 10.097656 25.398438 10.40625 25.855469 C 10.660156 26.917969 10.246094 27.460938 9.171875 27.480469 C 8.507812 27.265625 8.222656 26.808594 8.3125 26.113281 C 8.464844 25.714844 8.730469 25.441406 9.105469 25.285156 Z M 9.105469 25.285156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.627451%,20.784314%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 33.984375 25.476562 C 34.921875 25.386719 35.523438 25.789062 35.792969 26.683594 C 35.78125 27.96875 35.132812 28.53125 33.859375 28.371094 C 32.902344 27.882812 32.636719 27.152344 33.066406 26.175781 C 33.136719 26.042969 33.230469 25.925781 33.351562 25.824219 C 33.546875 25.671875 33.757812 25.554688 33.984375 25.476562 Z M 33.984375 25.476562 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.843137%,20.392157%,24.705882%)",
      fillOpacity: 1
    },
    d: "M 39.316406 26.300781 C 41.125 26.117188 42.238281 26.898438 42.648438 28.65625 C 42.5625 30.707031 41.492188 31.671875 39.441406 31.550781 C 37.925781 31.085938 37.238281 30.054688 37.378906 28.464844 C 37.617188 27.367188 38.265625 26.648438 39.316406 26.300781 Z M 39.316406 26.300781 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.627451%,20.784314%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 15.328125 26.492188 C 16.59375 26.417969 17.15625 27.011719 17.007812 28.273438 C 16.625 28.980469 16.046875 29.246094 15.261719 29.070312 C 14.378906 28.539062 14.199219 27.832031 14.722656 26.9375 C 14.917969 26.773438 15.121094 26.625 15.328125 26.492188 Z M 15.328125 26.492188 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(2.745098%,56.078431%,73.333333%)",
      fillOpacity: 1
    },
    d: "M 3.523438 26.8125 C 5.277344 26.714844 6.15625 27.542969 6.15625 29.292969 C 5.78125 30.578125 4.925781 31.160156 3.585938 31.042969 C 2.316406 30.617188 1.777344 29.734375 1.96875 28.402344 C 2.242188 27.625 2.761719 27.097656 3.523438 26.8125 Z M 3.523438 26.8125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.803922%,21.568627%,25.882353%)",
      fillOpacity: 1
    },
    d: "M 27.765625 27.003906 C 28.59375 26.859375 29.003906 27.199219 29.003906 28.019531 C 28.65625 28.683594 28.171875 28.8125 27.542969 28.402344 C 27.199219 27.867188 27.273438 27.402344 27.765625 27.003906 Z M 27.765625 27.003906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.627451%,20.784314%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 18.246094 28.527344 C 19.488281 28.511719 19.960938 29.105469 19.671875 30.308594 C 19.234375 30.878906 18.671875 31.039062 17.992188 30.785156 C 17.4375 30.371094 17.277344 29.828125 17.515625 29.164062 C 17.695312 28.867188 17.9375 28.65625 18.246094 28.527344 Z M 18.246094 28.527344 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.411765%,21.176471%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 24.910156 28.785156 C 25.90625 28.648438 26.339844 29.074219 26.210938 30.054688 C 25.964844 30.535156 25.574219 30.734375 25.035156 30.660156 C 24.402344 30.324219 24.222656 29.828125 24.496094 29.164062 C 24.628906 29.023438 24.765625 28.894531 24.910156 28.785156 Z M 24.910156 28.785156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.019608%,21.176471%,25.490196%)",
      fillOpacity: 1
    },
    d: "M 21.671875 29.292969 C 22.765625 29.296875 23.179688 29.824219 22.910156 30.882812 C 22.589844 31.386719 22.136719 31.566406 21.546875 31.421875 C 20.976562 31.089844 20.777344 30.589844 20.941406 29.929688 C 21.121094 29.632812 21.363281 29.421875 21.671875 29.292969 Z M 21.671875 29.292969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.627451%,20.784314%,25.098039%)",
      fillOpacity: 1
    },
    d: "M 31.003906 29.609375 C 32.4375 29.597656 33.082031 30.296875 32.9375 31.710938 C 32.597656 32.648438 31.933594 33.039062 30.9375 32.886719 C 30 32.550781 29.589844 31.882812 29.699219 30.882812 C 29.921875 30.226562 30.355469 29.804688 31.003906 29.609375 Z M 31.003906 29.609375 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(5.098039%,56.470588%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 12.027344 29.863281 C 13.015625 29.910156 13.34375 30.398438 13.011719 31.328125 C 12.613281 31.742188 12.160156 31.816406 11.644531 31.550781 C 11.296875 31.152344 11.242188 30.71875 11.488281 30.246094 C 11.632812 30.0625 11.8125 29.933594 12.027344 29.863281 Z M 12.027344 29.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.235294%,20.392157%,24.705882%)",
      fillOpacity: 1
    },
    d: "M 26.433594 32.28125 C 28.03125 32.179688 28.804688 32.921875 28.75 34.507812 C 28.347656 35.695312 27.53125 36.148438 26.304688 35.875 C 25.308594 35.382812 24.9375 34.585938 25.195312 33.492188 C 25.433594 32.902344 25.84375 32.5 26.433594 32.28125 Z M 26.433594 32.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(7.843137%,20.392157%,24.705882%)",
      fillOpacity: 1
    },
    d: "M 35.191406 32.28125 C 36.886719 32.140625 38.042969 32.863281 38.648438 34.445312 C 38.921875 36.304688 38.171875 37.523438 36.398438 38.101562 C 34.632812 38.285156 33.480469 37.53125 32.9375 35.84375 C 32.742188 34.050781 33.492188 32.863281 35.191406 32.28125 Z M 35.191406 32.28125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(8.235294%,20.392157%,24.705882%)",
      fillOpacity: 1
    },
    d: "M 21.230469 33.046875 C 22.722656 32.890625 23.589844 33.546875 23.832031 35.015625 C 23.625 36.539062 22.757812 37.207031 21.230469 37.019531 C 19.882812 36.4375 19.472656 35.453125 19.992188 34.0625 C 20.300781 33.59375 20.710938 33.253906 21.230469 33.046875 Z M 21.230469 33.046875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(9.803922%,57.254902%,74.117647%)",
      fillOpacity: 1
    },
    d: "M 16.34375 33.046875 C 17.167969 33.097656 17.433594 33.5 17.136719 34.253906 C 16.664062 34.695312 16.238281 34.65625 15.867188 34.125 C 15.71875 33.621094 15.875 33.257812 16.34375 33.046875 Z M 16.34375 33.046875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(3.529412%,56.078431%,73.333333%)",
      fillOpacity: 1
    },
    d: "M 7.773438 33.363281 C 8.847656 33.222656 9.597656 33.648438 10.027344 34.636719 C 10.25 35.941406 9.730469 36.757812 8.472656 37.085938 C 7.015625 37.042969 6.328125 36.289062 6.410156 34.828125 C 6.59375 34.082031 7.046875 33.59375 7.773438 33.363281 Z M 7.773438 33.363281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(3.137255%,56.078431%,73.333333%)",
      fillOpacity: 1
    },
    d: "M 14.121094 37.816406 C 15.628906 37.8125 16.253906 38.554688 15.992188 40.042969 C 15.429688 41.015625 14.636719 41.257812 13.613281 40.773438 C 12.914062 40.199219 12.734375 39.492188 13.074219 38.644531 C 13.339844 38.25 13.691406 37.976562 14.121094 37.816406 Z M 14.121094 37.816406 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(6.27451%,56.470588%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 29.035156 38.324219 C 29.800781 38.285156 30.246094 38.648438 30.367188 39.40625 C 30.125 40.429688 29.53125 40.714844 28.589844 40.265625 C 27.976562 39.441406 28.125 38.792969 29.035156 38.324219 Z M 29.035156 38.324219 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "evenodd",
      fill: "rgb(4.313725%,56.078431%,73.72549%)",
      fillOpacity: 1
    },
    d: "M 21.609375 39.535156 C 22.773438 39.5625 23.289062 40.15625 23.164062 41.3125 C 22.734375 42.191406 22.070312 42.433594 21.164062 42.046875 C 20.570312 41.523438 20.433594 40.898438 20.753906 40.167969 C 20.980469 39.867188 21.265625 39.652344 21.609375 39.535156 Z M 21.609375 39.535156 "
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGestelLogo);
export default __webpack_public_path__ + "static/media/Gestel-logo.ce5ed5994b7f389d2872acc7f1f12095.svg";
export { ForwardRef as ReactComponent };